import { CCardFooter } from "@coreui/react";
import { Box, Button, Card, CardContent, CardHeader, Divider, IconButton, MenuItem, Select, SelectChangeEvent, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useNavigation } from "react-router-dom";
import {AttachFile, Delete} from '@mui/icons-material'
import { T_Inquery } from "../../common/model/InqueryModel";
import apis from "../../common/apis";
import { initialAlert, useAlert } from "../../provider/AlertContextProvider";
import { T_Trouble } from "../../common/model/troubleModel";
import { T_Code } from "../../common/model/codeModel";
import { T_Board } from "../../common/model/boardModel";
import { T_File } from "../../common/model/fileModel";
import values from "../../common/values";
export default function TestBoardView(){
    const { state } = useLocation();
    // state.inqueryData 에서 넘어온 item 객체를 꺼낼 수 있습니다.
    const idata = state?.item;

    const nav = useNavigate();
    const [cstatus ,setCstatus] = useState('0');
    const [data,setData] = useState<T_Board>(idata);
    const {alert,setAlert} = useAlert();

      const handleDataDel = async(item:T_Board)=>{

        setAlert({...alert,visible:true,msg:"정말로 삭제 하시겠습니까?",buttonList:[{text:"예",variant:"contained",onPress:async()=>{
            console.log("del request:",item)
                const result = await apis.board.boardDelete(item);
                console.log("del result:",result)
                if(result.code=="1"){
                    setAlert(initialAlert);
                    setAlert({...alert,msg:"정상적으로 삭제되었습니다."})
                    nav("/testboard")                   
                  }else{
                    setAlert(initialAlert);
                    setAlert({...alert,msg:"삭제중 오류가 발생하였습니다다."})
                }
                
        }}
        ,{text:"아니요",variant:"outlined",onPress:()=>{
            setAlert({...alert,visible:false});

        }}
    ]})
    }  
      // 파일 다운로드
  const handleDownload = async (file: T_File) => {


      try {
        const url = `${values.server.url}/upload/${file.fileUrl??""}`;

        // 인증이 필요하면 credentials 옵션 추가
        const res = await fetch(url, { credentials: 'include' });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const blob = await res.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = file.fileOrgNm || 'download'; // 저장 파일명
        document.body.appendChild(a);
        a.click();
        a.remove();

        window.URL.revokeObjectURL(blobUrl);
      } catch (e) {
        setAlert({ ...initialAlert, visible: true, msg: '다운로드 중 오류가 발생했습니다.' });
        console.error(e);
  }

  };

  
     useEffect(()=>{
      console.log(data)
    },[])

     const getData = async()=>{
         const result = await apis.board.boardInfo({idx:data.idx})
         console.log("info:",result)
         if(result.code=="1"){
            setData(result.data);
         }
      }


    return(
     <>
    <Card >
        <CardHeader title="테스트현황 수정" sx={{pb:0,mb:0}}/>
        <CardContent>
            <Divider />
        <Table  stickyHeader aria-label="sticky table"  sx={{borderTopWidth:2
          }} > 
            <TableHead />
            <TableBody>
               
        <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          제목
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}} colSpan={3}>
                          {data.title}
                        </TableCell>      

        </TableRow>          

        <TableRow>          
        <TableCell component="th" scope="row" sx={{width:150}}>
                          내용
                        </TableCell>      
                        <TableCell sx={{textAlign:'left', whiteSpace: 'pre-line'}} colSpan={3}>
                        {data.contents}
                        </TableCell>      

        </TableRow>          
      
        {/* <TableRow>  
                       <TableCell component="th" scope="row" sx={{width:150}}>
                          비고
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}} colSpan={3}>
                          <TextField multiline
                            rows={10}
                            fullWidth 
                            value={data. || ''} onChange={(event)=>{setData({...data,contents:event.target.value})}}
                          />
                        </TableCell>      

        </TableRow>             */}
        <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          첨부파일
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}} colSpan={3}>
                         {data.files &&  data.files?.map((fileitem,idx)=>{
                            console.log("files:",fileitem.fileOrgNm)
                            return(<Box  
                                  key={idx}
                                 sx={{
                                 display: 'flex',
                                 alignItems: 'center',
                                 mt: 0.5,
                                 cursor:'pointer'
                               }}
                               onClick = {()=>{handleDownload(fileitem)}}
                               ><Typography>{fileitem.fileOrgNm}</Typography>
                            </Box>
                            )
                        })}
      
                        </TableCell>      

        </TableRow>        
        </TableBody>

        </Table>

        </CardContent>
        <CCardFooter style={{   display: 'flex',justifyContent:'center',textAlign:'center',paddingBottom:10, gap: '1rem'}}  >
        <Button variant="contained"    onClick={() => {
                          nav("/testboard/edit",{state:{item:data}})  
                        }}>수정</Button>
        <Button variant="contained"  onClick={async() => {
                          handleDataDel(data)
                        }}>삭제</Button>
        <Button variant="outlined" onClick={()=>{
         nav(-1);
         }}>목록</Button>
        </CCardFooter>
    </Card>

    </>)
}